import { computed } from 'vue'
import { getBooleanFromValue } from '@/global/utils/utils'
import { useAppContext } from '@/global/services/compositionApi/useAppContext'

export function useBreakpoint () {
  const { vuetify } = useAppContext()
  const bp = vuetify?.breakpoint

  const xs = computed(() => getBooleanFromValue(bp?.xs))
  const sm = computed(() => getBooleanFromValue(bp?.sm))
  const md = computed(() => getBooleanFromValue(bp?.md))
  const lg = computed(() => getBooleanFromValue(bp?.lg))
  const xl = computed(() => getBooleanFromValue(bp?.xl))

  const smAndDown = computed(() => getBooleanFromValue(bp?.smAndDown))
  const smAndUp = computed(() => getBooleanFromValue(bp?.smAndUp))
  const mdAndDown = computed(() => getBooleanFromValue(bp?.mdAndDown))
  const mdAndUp = computed(() => getBooleanFromValue(bp?.mdAndUp))
  const lgAndDown = computed(() => getBooleanFromValue(bp?.lgAndDown))
  const lgAndUp = computed(() => getBooleanFromValue(bp?.lgAndUp))

  const isMobile = computed(() => getBooleanFromValue(bp?.mobile))

  return {
    xs,
    sm,
    md,
    lg,
    xl,
    smAndDown,
    smAndUp,
    mdAndDown,
    mdAndUp,
    lgAndDown,
    lgAndUp,
    isMobile
  }
}
